"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px",
    lineHeight: "24px",
    fontWeight: "bold",
    color: theme.palette.text.secondary
  }
}));

const PreviewLabel = ({
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Typography.default, {
    className: classes.root
  }, children);
};

var _default = PreviewLabel;
exports.default = _default;
module.exports = exports.default;